import { c as _c } from "react/compiler-runtime";
import SvgAiSpark from '@common/icon/SvgAiSpark';
import { cn } from '@core/utils';
interface AiSummaryProps {
  aiSummaryList: string[];
}
export const AiSummary = t0 => {
  const $ = _c(7);
  const {
    aiSummaryList
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex w-full flex-col items-start overflow-hidden rounded-medium border border-B-50 px-20 py-16 shadow-md-reverse", "bg-[linear-gradient(128deg,theme(colors.Gray.white)_0%,theme(colors.B.25)_50%,theme(colors.Y.25)_100%)]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="flex size-20 items-center justify-center"><SvgAiSpark className="size-16" /></span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex w-full items-center gap-4">{t2}<span className="flex-1 text-left font-700 tracking-[-0.28px] text-Gray-900 typo-body4">정책을 <span className="text-B-500">AI</span>로 요약했어요</span></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== aiSummaryList) {
    t4 = aiSummaryList.map(_temp);
    $[3] = aiSummaryList;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className={t1}>{t3}<div className="flex flex-col gap-12 pt-16">{t4}</div></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
function _temp(value, index) {
  return <p key={index} className="font-400 tracking-[-0.28px] text-Gray-900 typo-body4">{value}</p>;
}